import FormatService from './format-service';
import StructureService from './structure-service';
import {
  LOCAL_STORAGE_KEY_AUTHORIZATION, LOCAL_STORAGE_KEY_FIXED_NAVIGATION_DRAWER, LOCAL_STORAGE_KEY_FIXED_RIGHT_DRAWER,
  LOCAL_STORAGE_KEY_CARD_VIEW, LOCAL_STORAGE_KEY_DEVICE_ID, LOCAL_STORAGE_KEY_OKTA_ACCOUNT_NAME,
  LOCAL_STORAGE_KEY_OKTA_ACCOUNT_CLIENT_ID, LOCAL_STORAGE_KEY_DEAL_SCHEDULE_ZOOM,
  LOCAL_STORAGE_KEY_PORTFOLIO_FILTER_IDS, LOCAL_STORAGE_KEY_PORTFOLIO_GROUP_FILTER_IDS,
  LOCAL_STORAGE_KEY_PUSH_NOTIFICATION_TOKEN,
} from '../constants/system/local-storage-keys';

export default class LocalStorageService {
  public static setAuthToken(authToken: string): void {
    localStorage.setItem(LOCAL_STORAGE_KEY_AUTHORIZATION, authToken);
  }

  public static getAuthToken(): string | null {
    return localStorage.getItem(LOCAL_STORAGE_KEY_AUTHORIZATION) || null;
  }

  public static deleteAuthToken(): void {
    localStorage.removeItem(LOCAL_STORAGE_KEY_AUTHORIZATION);
  }

  public static setDeviceId(deviceId: string): void {
    localStorage.setItem(LOCAL_STORAGE_KEY_DEVICE_ID, deviceId);
  }

  public static getDeviceId(): string | null {
    return localStorage.getItem(LOCAL_STORAGE_KEY_DEVICE_ID) || null;
  }

  public static setPushNotificationToken(pushNotificationToken: string): void {
    localStorage.setItem(LOCAL_STORAGE_KEY_PUSH_NOTIFICATION_TOKEN, pushNotificationToken);
  }

  public static getPushNotificationToken(): string | null {
    return localStorage.getItem(LOCAL_STORAGE_KEY_PUSH_NOTIFICATION_TOKEN) || null;
  }

  public static setOktaAccountName(oktaAccountName: string): void {
    localStorage.setItem(LOCAL_STORAGE_KEY_OKTA_ACCOUNT_NAME, oktaAccountName);
  }

  public static getOktaAccountName(): string | null {
    return localStorage.getItem(LOCAL_STORAGE_KEY_OKTA_ACCOUNT_NAME) || null;
  }

  public static setOktaAccountClientId(oktaClientId: string): void {
    localStorage.setItem(LOCAL_STORAGE_KEY_OKTA_ACCOUNT_CLIENT_ID, oktaClientId);
  }

  public static getOktaAccountClientId(): string | null {
    return localStorage.getItem(LOCAL_STORAGE_KEY_OKTA_ACCOUNT_CLIENT_ID) || null;
  }

  public static setFixedNavigationDrawer(isFixedNavigationDrawer: boolean): void {
    localStorage.setItem(LOCAL_STORAGE_KEY_FIXED_NAVIGATION_DRAWER, (+isFixedNavigationDrawer).toString());
  }

  public static hasFixedNavigationDrawerValue(): boolean {
    return !!localStorage.getItem(LOCAL_STORAGE_KEY_FIXED_NAVIGATION_DRAWER);
  }

  public static getFixedNavigationDrawerValue(): boolean {
    return !!FormatService.parseInt(localStorage.getItem(LOCAL_STORAGE_KEY_FIXED_NAVIGATION_DRAWER) || '');
  }

  public static setFixedRightDrawer(isFixedRightDrawer: boolean): void {
    localStorage.setItem(LOCAL_STORAGE_KEY_FIXED_RIGHT_DRAWER, (+isFixedRightDrawer).toString());
  }

  public static hasFixedRightDrawerValue(): boolean {
    return !!localStorage.getItem(LOCAL_STORAGE_KEY_FIXED_RIGHT_DRAWER);
  }

  public static getFixedRightDrawerValue(): boolean {
    return !!FormatService.parseInt(localStorage.getItem(LOCAL_STORAGE_KEY_FIXED_RIGHT_DRAWER) || '');
  }

  public static setCardViewValue(cardViewValue: boolean): void {
    localStorage.setItem(LOCAL_STORAGE_KEY_CARD_VIEW, (+cardViewValue).toString());
  }

  public static hasCardViewValue(): boolean {
    return !!localStorage.getItem(LOCAL_STORAGE_KEY_CARD_VIEW);
  }

  public static getCardViewValue(): boolean {
    return !!FormatService.parseInt(localStorage.getItem(LOCAL_STORAGE_KEY_CARD_VIEW) || '');
  }

  public static hasDealScheduleZoom(): boolean {
    return !!localStorage.getItem(LOCAL_STORAGE_KEY_DEAL_SCHEDULE_ZOOM);
  }

  public static getDealScheduleZoom(): string | null {
    return localStorage.getItem(LOCAL_STORAGE_KEY_DEAL_SCHEDULE_ZOOM);
  }

  public static setDealScheduleZoom(dealScheduleZoom: string): void {
    localStorage.setItem(LOCAL_STORAGE_KEY_DEAL_SCHEDULE_ZOOM, dealScheduleZoom);
  }

  public static getPortfolioFilterIds(): number[] {
    const storedPortfolioFilterIds: JsonObject | string[] | null = FormatService.extractJson(
      localStorage.getItem(LOCAL_STORAGE_KEY_PORTFOLIO_FILTER_IDS),
    );

    return storedPortfolioFilterIds && StructureService.checkIsValueArray(storedPortfolioFilterIds)
      ? storedPortfolioFilterIds.map((storedPortfolioFilterId: string): number => (
        FormatService.parseInt(storedPortfolioFilterId)
      )) : [];
  }

  public static setPortfolioFilterIds(portfolioFilterIds?: number[]): void {
    localStorage.setItem(
      LOCAL_STORAGE_KEY_PORTFOLIO_FILTER_IDS,
      FormatService.formatJsonString(portfolioFilterIds) as string,
    );
  }

  public static getPortfolioGroupFilterIds(): number[] {
    const storedPortfolioGroupFilterIds: JsonObject | string[] | null = FormatService.extractJson(
      localStorage.getItem(LOCAL_STORAGE_KEY_PORTFOLIO_GROUP_FILTER_IDS),
    );

    return storedPortfolioGroupFilterIds && StructureService.checkIsValueArray(storedPortfolioGroupFilterIds)
      ? storedPortfolioGroupFilterIds.map((storedPortfolioGroupFilterId: string): number => (
        FormatService.parseInt(storedPortfolioGroupFilterId)
      )) : [];
  }

  public static setPortfolioGroupFilterIds(portfolioGroupFilterIds?: number[]): void {
    localStorage.setItem(
      LOCAL_STORAGE_KEY_PORTFOLIO_GROUP_FILTER_IDS,
      FormatService.formatJsonString(portfolioGroupFilterIds) as string,
    );
  }
}
